<template>
  <div>
    <m-modal-setting ref="modalSetting"></m-modal-setting>
    <m-modal-pricing></m-modal-pricing>
    <m-modal-digital-campaigns />

    <m-contact-us />
    <b-navbar toggleable="md" class="navbar header-top-scrool">
      <b-container fluid class="m-layout-content">
        <b-navbar-brand :href="indexUrl">
          <div class="logo"></div>
        </b-navbar-brand>

        <b-nav-toggle target="nav_collapse" postion="left" right></b-nav-toggle>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-link
              class="nav-link nav-link-top item-highlight"
              v-m-ua-event="['header', 'user', 'order history']"
              >{{ this.$store.state.site.PhoneNumber }}</b-link
            >
            <b-link
              class="nav-link nav-link-top item-highlight"
              :href="'mailto:' + this.$store.state.site.ContactEmail"
              v-m-ua-event="['header', 'user', 'order history']"
              >Contact Us</b-link
            >
            <b-link
              class="nav-link nav-link-top item-highlight"
              v-b-modal.modalPricing
              data-test="headPricing"
              @click="goPage"
              v-m-ua-event="['header', 'user', 'pricing']"
              :hidden="this.$store.state.site.User_RoleName === 'Digital User'"
            >
              Pricing
            </b-link>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
import MModalPricing from "@/components/landings/MModalPricing";
import MModalSetting from "@/components/landings/MModalSetting";
import jsCookie from "js-cookie";
import MContactUs from "@/components/landings/MContactUs";
import MModalDigitalCampaigns from "@/components/landings/MModalDigitalCampaigns";
import MNav from "@/components/layouts/MNav";
import notificaton from "@/components/common/notification";
import utils from "@/assets/utils";

export default {
  components: {
    MModalPricing,
    MModalSetting,
    MContactUs,
    MModalDigitalCampaigns,
    MNav,
  },
  computed: {
    indexUrl() {
      return this.$store.state.site.HomePageLink && this.$store.state.site.HomePageLink !== ""
        ? this.$store.state.site.HomePageLink
        : utils.getRootPath();
    },
    username() {
      return this.$store.state.site.User_FullName || "welcome";
    },
    userimg() {
      return this.$store.state.site.UserImg;
    },
    userDataSources() {
      return this.$store.state.user.userDataSources;
    },
    userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources;
    },
    topBtns() {
      var result = [];
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType === 10 || item.ListType === 170) {
          result.push(item);
        }
      }
      return result;
    },
    normalBtns() {
      var result = [];
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType !== 10 && item.ListType !== 170) {
          result.push(item);
        }
      }
      return result;
    },
    menus() {
      var result = [
        {
          title: "Append Demographics or Psychographics",
          benefit:
            "Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.",
          link: "enhanceList",
          icon: "share-alt",
          type: "enhance",
          show: this.userServiceDataSources.showEnhanceList,
        },
        {
          title: "Clean your Database",
          benefit:
            "Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.",
          link: "cleanList",
          icon: "eraser",
          type: "clean",
          show: this.userServiceDataSources.showCleanList,
        },
        {
          title: "Append Email Addresses",
          benefit:
            "Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.",
          link: "emailAppend",
          icon: "envelope-open-o",
          type: "enhance",
          show: this.userServiceDataSources.showEmailAppend,
        },
        {
          title: "Verify Email Addresses",
          benefit:
            "Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.",
          link: "emailVerification",
          icon: "envelope-o",
          type: "clean",
          show: this.userServiceDataSources.showEmailVerification,
        },
        {
          title: "Append Phone Numbers",
          benefit:
            "Provides an additional and low cost channel to communicate with customers.",
          link: "phoneAppend",
          icon: "phone",
          type: "enhance",
          show: this.userServiceDataSources.showPhoneAppend,
        },
        {
          title: "Reverse Phone Append",
          benefit:
            "Helps reveal who contacted you and enables you to reach them via direct mail.",
          link: "phoneReverse",
          icon: "phone",
          type: "enhance",
          show: this.userServiceDataSources.showPhoneReverse,
        },
        {
          title: "Reverse Email Append",
          benefit:
            "Helps reveal who contacted you and enables you to reach them via direct mail.",
          link: "reverseEmailAppend",
          icon: "envelope-open-o",
          type: "enhance",
          show: this.userServiceDataSources.showEmailReverse,
        },
        {
          title: "Phone Confirmation & Append",
          benefit:
            "Saves you time calling bad numbers and improves your connection rate with customers.",
          link: "phoneVerification",
          icon: "volume-control-phone",
          type: "clean",
          show: this.userServiceDataSources.showPhoneVerification,
        },
      ];
      return result;
    },
    showHistoryMenu() {
      if (
        this.$store.state.user.ShowDigitalHistory &&
        this.$store.state.user.ShowOrderHistory
      ) {
        return true;
      } else {
        return false;
      }
    },
    showOrderHistoryMenu() {
      if (
        !this.$store.state.user.ShowDigitalHistory &&
        this.$store.state.user.ShowOrderHistory
      ) {
        return true;
      } else {
        return false;
      }
    },
    showDigitalHistoryMenu() {
      if (
        this.$store.state.user.ShowDigitalHistory &&
        !this.$store.state.user.ShowOrderHistory
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      info: {
        name: "",
        email: "",
        message: "",
      },
      btnDisable: false,
      infoValid: {
        name: {
          state: null,
          text: "",
        },
        email: {
          state: null,
          text: "",
        },
        message: {
          state: null,
          text: "",
        },
      },
      isShowSuccess: false,
    };
  },
  methods: {
    go(listType) {
      this.$router.push({
        name: "order",
        params: {
          listType: listType,
        },
      });
      this.$root.$emit("closeAllNav");
    },
    goPage(cb) {
      if (typeof cb === "function") {
        cb();
      }
      this.$root.$emit("closeAllNav");
    },
    gotoDigitalReporting() {
      this.$router.push({
        name: "DigitalReporting",
      });
    },
    showContactUs() {
      this.$root.$emit("bv::show::modal", "modalContactUs");
      this.$root.$emit("closeAllNav");
    },
    showContactUsFreeDiagnostic() {
      this.$root.$emit("bv::show::modal", "modalContactUsFreeDiagnostic");
      this.$root.$emit("closeAllNav");
    },
    logOut() {
      window.location = this.$store.getters["config/link"]("logOut");
      jsCookie.remove("denglu");
    },
    submit() {
      this.clearValid(this.infoValid);
      let that = this;
      if (this.validInfo()) {
        this.btnDisable = true;
        this.$http
          .post(
            this.$store.getters["config/link"]("sendMessage"),
            {
              Action: "save-contact-info",
              FormData: JSON.stringify({
                FirstName: this.info.name,
                LastName: "",
                Company: "",
                Email: this.info.email,
                Phone: "",
                Comment: this.info.message,
                Page: "SL360",
                PageInfo: "SL360",
                FromSite: "SL360",
                Source: "",
                fromsite: "SL360",
              }),
            },
            {
              emulateJSON: true,
            }
          )
          .then(
            (resp) => {
              that.btnDisable = false;
              if (resp.body.Status === 1) {
                notificaton.notice("success", "Message successfully sent");
                this.$root.$emit("closeAllNav");
              } else {
                notificaton.notice("error", "Message failed to be sent");
              }
            },
            (resp) => {
              this.btnDisable = false;
            }
          );
      }
    },
    validInfo() {
      let isValid = true;
      if (!this.info.name) {
        this.infoValid.name.state = false;
        this.infoValid.name.text = "It's required";
        isValid = false;
      }
      if (
        !(
          this.info.email.indexOf("@") > 0 &&
          this.info.email.indexOf("@") < this.info.email.length - 1
        )
      ) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "E-mail must be valid";
        isValid = false;
      }
      if (!this.info.email) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.info.message) {
        this.infoValid.message.state = false;
        this.infoValid.message.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    clearValid(items) {
      for (let key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    },
    getMenuActive(m) {
      if (this.$route.path === m) return true;
      else return false;
    },
    gotoOrderHistory() {
      this.$router.push({
        name: "orderhistory",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.img-logo {
  height: 51px;
  width: auto;
  margin-top: 8px;
  margin-bottom: 8px;
}

.user {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  vertical-align: middle;
  margin-right: 10px;
}

.ml-auto {
  display: flex;
  align-items: center;
}

.nav-item {
  font-size: 16px;
}

.user-name {
  font-weight: bold;
}

.twitter-icon {
  color: $color-primary;
}

.the-nav-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.nav-block {
  flex-grow: 1;
  max-width: 30%;
}

@media (max-width: 768px) {
  .the-nav-box {
    flex-direction: column;
  }

  .nav-block {
    max-width: 100% !important;
    width: 100%;
  }
}

.nav-brief {
  color: $color-white;
}

.nav-title {
  margin-bottom: 0;
  color: $color-primary;
  font-size: 16px;
}

.nav-icon {
  margin-right: 8px;
  width: 16px;
}

.nav-link {
  color: $color-white;
  text-decoration: none;
}

.nav-link-top {
  z-index: 101;
}

.nav-breif {
  color: $color-white;
}
</style>
<style>
nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MHeader.vue